import { Card, Divider } from "@mui/material"
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { useCookies } from "react-cookie";
import { useEffect } from "react";
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import BusinessIcon from '@mui/icons-material/Business';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { useDispatch, useSelector } from "react-redux";
import { getBizID, getStyle } from "../../libs/todoSlice";
import { getBusinessAddressRedux, getBusinessRedux, setBusinessAddressRedux, setBusinessRedux } from "../../libs/profileSlice";
import LoadingComponent from "../../lib/LoadingComponent";

const Businesses = () => {
  const [cookie, setCookie] = useCookies(['account'])
  const [businesses, setBusinesses] = useState([])
  const dispatch = useDispatch()
  const style = useSelector(getStyle)
  const business_id = useSelector(getBizID)
  const business = useSelector(getBusinessRedux)
  const businessAddress = useSelector(getBusinessAddressRedux)

  const setBusiness = (action) => {
    dispatch(setBusinessRedux({
      business: action,
    }))
  }
  const setBusinessAddress = (action) => {
    dispatch(setBusinessAddressRedux({
      businessAddress: action,
    }))
  }

  useEffect(() => {
    getBusinesses()
  }, [])


  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const getBusinesses = async () => {
    setLoading(true)
    try {
      const { data, status } = await axios({
        method: 'GET',
        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/profile/businesses/${business_id}`,
      })
      setBusiness(data.data)
      setBusinessAddress(data.data.address)
      setLoading(false)
    } catch ({ response }) {
      setLoading(false)
    }

  }
  return !loading ? (
    <div>
      <div className="row">
        <div className="col text-start">
          <span
            style={{
              color: 'rgba(43, 161, 151, 1)',
              fontSize: '20px',

            }}
          >
            <strong style={{ color: 'black' }}>
              ข้อมูลนิติบุคคล
            </strong>
          </span>
          <div style={{ marginBottom: '20px', marginTop: '15px' }}>
            <div style={{ fontFamily: 'Sarabun', fontWeight: '600', fontSize: '18px', marginBottom: '10px', color: '#333333', display: 'flex' }}>ความน่าเชื่อถือ :
              {(() => {
                if (business.trust_level === "0") {
                  return (<div style={{ color: '#FF0000' }}>Level 0</div>)
                }
                else if (business.trust_level === "1") {
                  return (<div style={{ color: '#E9A016' }}>Level 1</div>)
                }
                else if (business.trust_level === "2") {
                  return (<div style={{ color: '#119143' }}>Level 2</div>)
                }
              })()}</div>
          </div>
        </div>
      </div>
      <div className="row my-5">
        <div className="col">
          <Stepper activeStep={business.trust_level} alternativeLabel>
            <Step key={1}>
              <StepLabel
                StepIconComponent={(props) => {
                  const { active, completed, className } = props;
                  return (
                    <div
                      className="text-center"
                      style={{
                        backgroundColor: completed ? 'rgba(43, 161, 151, 1)' : '#9E9E9E',
                        width: '24px',
                        maxWidth: '50px',
                        color: '#FFFFFF',
                        borderRadius: '100%'
                      }}
                    >
                      1
                    </div>
                  );
                }}
              >
              </StepLabel>
            </Step>
            <Step key={2}>
              <StepLabel
                StepIconComponent={(props) => {
                  const { active, completed, className } = props;
                  return (
                    <div
                      className="text-center"
                      style={{
                        backgroundColor: completed ? 'rgba(43, 161, 151, 1)' : '#9E9E9E',
                        width: '24px',
                        maxWidth: '50px',
                        color: '#FFFFFF',
                        borderRadius: '100%'
                      }}
                    >
                      2
                    </div>
                  );
                }}
              >
              </StepLabel>
            </Step>
          </Stepper>
        </div>
      </div>
      <div className="row my-3 text-start">
        <div className="col-12 col-md-4">
          <div className="row mt-3 mt-md-0">
            <div className="col">
              <span
                style={{
                  color: 'rgba(126, 126, 126, 1)',
                  fontSize: '14px'
                }}
              >
                ประเภทนิติบุคคล (ไทย) :
              </span>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <span
                style={{
                  fontSize: '16px'
                }}
              >
                {business.title_th ?? '-'}
              </span>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col">
              <span
                style={{
                  color: 'rgba(126, 126, 126, 1)',
                  fontSize: '14px'
                }}
              >
                ประเภทนิติบุคคล (อังกฤษ) :
              </span>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <span
                style={{
                  fontSize: '16px'
                }}
              >
                {business.title_eng ?? '-'}
              </span>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col">
              <span
                style={{
                  color: 'rgba(126, 126, 126, 1)',
                  fontSize: '14px'
                }}
              >
                เลขนิติบุคคล :
              </span>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <span
                style={{
                  fontSize: '16px'
                }}
              >
                {business.tax_id}
              </span>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col">
              <span
                style={{
                  color: 'rgba(126, 126, 126, 1)',
                  fontSize: '14px'
                }}
              >
                ชื่อสาขา :
              </span>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <span
                style={{
                  fontSize: '16px'
                }}
              >
                {business.branch_name ?? '-'}
              </span>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-4">
          <div className="row mt-3 mt-md-0">
            <div className="col">
              <span
                style={{
                  color: 'rgba(126, 126, 126, 1)',
                  fontSize: '14px'
                }}
              >
                ชื่อบริษัท (ไทย) :
              </span>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <span
                style={{
                  fontSize: '16px'
                }}
              >
                {business.name_th ?? '-'}
              </span>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col">
              <span
                style={{
                  color: 'rgba(126, 126, 126, 1)',
                  fontSize: '14px'
                }}
              >
                ชื่อบริษัท (อังกฤษ) :
              </span>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <span
                style={{
                  fontSize: '16px'
                }}
              >
                {business.name_eng ?? '-'}
              </span>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col">
              <span
                style={{
                  color: 'rgba(126, 126, 126, 1)',
                  fontSize: '14px'
                }}
              >
                อีเมล :
              </span>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <span
                style={{
                  fontSize: '16px'
                }}
              >
                {business.onemail ?? '-'}
              </span>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col">
              <span
                style={{
                  color: 'rgba(126, 126, 126, 1)',
                  fontSize: '14px'
                }}
              >
                รหัสสาขา :
              </span>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <span
                style={{
                  fontSize: '16px'
                }}
              >
                {business.branch_NO ?? '-'}
              </span>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-4">
          <div className="row mt-3 mt-md-0">
            <div className="col">
              <span
                style={{
                  color: 'rgba(126, 126, 126, 1)',
                  fontSize: '14px'
                }}
              >
                ชื่อสำหรับแสดงบนเอกสาร (ไทย)
              </span>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <span
                style={{
                  fontSize: '16px'
                }}
              >
                {business.name_on_document_th ?? '-'}
              </span>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col">
              <span
                style={{
                  color: 'rgba(126, 126, 126, 1)',
                  fontSize: '14px'
                }}
              >
                ชื่อสำหรับแสดงบนเอกสาร (อังกฤษ)
              </span>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <span
                style={{
                  fontSize: '16px'
                }}
              >
                {business.name_on_document_eng ?? '-'}
              </span>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col">
              <span
                style={{
                  color: 'rgba(126, 126, 126, 1)',
                  fontSize: '14px'
                }}
              >
                โทรสาร :
              </span>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <span
                style={{
                  fontSize: '16px'
                }}
              >
                {businessAddress.fax_number ?? '-'}
              </span>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col">
              <span
                style={{
                  color: 'rgba(126, 126, 126, 1)',
                  fontSize: '14px'
                }}
              >
                เลขรหัสประจำที่อยู่ :
              </span>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <span
                style={{
                  fontSize: '16px'
                }}
              >
                {businessAddress.house_code ?? '-'}
              </span>
            </div>
          </div>
        </div>
      </div>

      <Divider />

      <div className="row my-3 text-start">
        <div className="col-12 col-md-4">
          <div className="row mt-3 mt-md-0">
            <div className="col">
              <span
                style={{
                  color: 'rgba(126, 126, 126, 1)',
                  fontSize: '14px'
                }}
              >
                ที่อยู่ :
              </span>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <span
                style={{
                  fontSize: '16px'
                }}
              >
                {businessAddress.house_no ?? '-'}
              </span>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col">
              <span
                style={{
                  color: 'rgba(126, 126, 126, 1)',
                  fontSize: '14px'
                }}
              >
                อาคาร :
              </span>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <span
                style={{
                  fontSize: '16px'
                }}
              >
                {businessAddress.building_name ?? '-'}
              </span>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col">
              <span
                style={{
                  color: 'rgba(126, 126, 126, 1)',
                  fontSize: '14px'
                }}
              >
                ตรอก/ซอย :
              </span>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <span
                style={{
                  fontSize: '16px'
                }}
              >
                {businessAddress.soi ?? '-'}
              </span>
            </div>
          </div>
          <div className="row">
            <div className="col mt-3">
              <span
                style={{
                  color: 'rgba(126, 126, 126, 1)',
                  fontSize: '14px'
                }}
              >
                แขวง (ตำบล) :
              </span>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <span
                style={{
                  fontSize: '16px'
                }}
              >
                {businessAddress.tumbon ?? '-'}
              </span>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col">
              <span
                style={{
                  color: 'rgba(126, 126, 126, 1)',
                  fontSize: '14px'
                }}
              >
                รหัสไปรษณีย์ :
              </span>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <span
                style={{
                  fontSize: '16px'
                }}
              >
                {businessAddress.zipcode ?? '-'}
              </span>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-4">
          <div className="row mt-3 mt-md-0">
            <div className="col">
              <span
                style={{
                  color: 'rgba(126, 126, 126, 1)',
                  fontSize: '14px'
                }}
              >
                ห้องเลขที่ :
              </span>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <span
                style={{
                  fontSize: '16px'
                }}
              >
                {businessAddress.room_no ?? '-'}
              </span>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col">
              <span
                style={{
                  color: 'rgba(126, 126, 126, 1)',
                  fontSize: '14px'
                }}
              >
                หมู่บ้าน :
              </span>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <span
                style={{
                  fontSize: '16px'
                }}
              >
                {businessAddress.moo_ban ?? '-'}
              </span>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col">
              <span
                style={{
                  color: 'rgba(126, 126, 126, 1)',
                  fontSize: '14px'
                }}
              >
                แยก :
              </span>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <span
                style={{
                  fontSize: '16px'
                }}
              >
                {businessAddress.yaek ?? '-'}
              </span>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col">
              <span
                style={{
                  color: 'rgba(126, 126, 126, 1)',
                  fontSize: '14px'
                }}
              >
                เขต (อำเภอ) :
              </span>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <span
                style={{
                  fontSize: '16px'
                }}
              >
                {businessAddress.amphoe ?? '-'}
              </span>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-4">
          <div className="row mt-3 mt-md-0">
            <div className="col">
              <span
                style={{
                  color: 'rgba(126, 126, 126, 1)',
                  fontSize: '14px'
                }}
              >
                ชั้นที่ :
              </span>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <span
                style={{
                  fontSize: '16px'
                }}
              >
                {businessAddress.floor ?? '-'}
              </span>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col">
              <span
                style={{
                  color: 'rgba(126, 126, 126, 1)',
                  fontSize: '14px'
                }}
              >
                หมู่ที่ :
              </span>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <span
                style={{
                  fontSize: '16px'
                }}
              >
                {businessAddress.moo_no ?? '-'}
              </span>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col">
              <span
                style={{
                  color: 'rgba(126, 126, 126, 1)',
                  fontSize: '14px'
                }}
              >
                ถนน :
              </span>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <span
                style={{
                  fontSize: '16px'
                }}
              >
                {businessAddress.street ?? '-'}
              </span>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col">
              <span
                style={{
                  color: 'rgba(126, 126, 126, 1)',
                  fontSize: '14px'
                }}
              >
                จังหวัด :
              </span>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <span
                style={{
                  fontSize: '16px'
                }}
              >
                {businessAddress.province ?? '-'}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : <LoadingComponent width={500} height={500} />
}

export default Businesses